import React from 'react';
import PropTypes from 'prop-types';
import {
  ListItem as MuiListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
} from '@material-ui/core';
import cn from 'classnames';
import { capitalize } from 'lodash';

const useStyles = makeStyles(() => ({
  listItemText: {
    marginTop: 0,
    marginBottom: 0,
  },
  listItem: {
    marginTop: 0,
    paddingTop: '0.8rem',
    paddingBottom: '0.8rem',
    '&:hover': {
      background: 'transparent !important',
    },
  },
  listItemIcon: {
    marginTop: 0,
    minWidth: '1px',
    marginRight: '0.8rem',
    position: 'relative',
    padding: '3px',
  },

  iconSizeSmall: {
    height: '2rem',
    width: '2rem',
  },
  iconSizeMedium: {
    height: '4rem',
    width: '4rem',
  },
  iconSizeAuto: {
    height: 'auto',
    width: 'auto',
  },
}));

const ListItem = ({
  value,
  icon,
  IconComponent,
  iconProps = { size: 'default' },
  className,
  secondaryValue,
  secondaryTypographyProps = { color: 'default' },
  ...props
}) => {
  const classes = useStyles();
  return (
    <MuiListItem
      disableGutters
      className={cn(classes.listItem, className)}
      {...props}
    >
      {(IconComponent || icon) && (
        <ListItemIcon
          className={cn(
            classes.listItemIcon,
            classes[`iconSize${capitalize(iconProps.size)}`],
            iconProps.className,
          )}
        >
          {IconComponent || <img src={icon} alt={value} />}
        </ListItemIcon>
      )}
      <ListItemText
        className={classes.listItemText}
        primary={value}
        secondary={secondaryValue}
        secondaryTypographyProps={secondaryTypographyProps}
      />
    </MuiListItem>
  );
};

ListItem.propTypes = {
  value: PropTypes.object,
  icon: PropTypes.string,
  IconComponent: PropTypes.object,
  iconProps: PropTypes.object,
  className: PropTypes.string,
  secondaryValue: PropTypes.object,
  secondaryTypographyProps: PropTypes.object,
};

export default ListItem;
